export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/3fadfda14f341399d663fd2ed398d959.svg";